.wrapper {
  display: flex;
  justify-content: center;
  margin: 24px 0;
}
